import ContentLoader from 'react-content-loader'

const CouponLoader = (props) => (
  <div
    style={{
      border: '1px #F5F5F5 solid',
      borderRadius: '7px'
    }}
    {...props}
  >
    <ContentLoader
      uniqueKey="coupon-loader"
      speed={2}
      width={340}
      height={100}
      viewBox="0 0 340 100"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="16" y="18" rx="10" ry="10" width="156" height="20" />
      <rect x="16" y="46" rx="8" ry="8" width="123" height="15" />
      <rect x="16" y="69" rx="8" ry="8" width="71" height="15" />
    </ContentLoader>
  </div>
)

export default CouponLoader
